<script setup>
import { ref, onMounted } from 'vue'
import { useStripe } from '@/hooks/useStripe'

defineProps({
  stripeError: { type: String, default: '' },
})

const cardNumberEl = ref(null)
const cardExpiryEl = ref(null)
const cardCvcEl = ref(null)

const { initializeStripeSplit } = useStripe()

const mount = () => {
  initializeStripeSplit({
    cardNumberEl: cardNumberEl.value,
    cardExpiryEl: cardExpiryEl.value,
    cardCvcEl: cardCvcEl.value,
  })
}

onMounted(() => {
  if (!window.Stripe) {
    const script = document.createElement('script')
    script.src = 'https://js.stripe.com/v3/'
    script.async = true
    script.onload = mount
    document.head.appendChild(script)
  } else {
    mount()
  }
});
</script>

<template>
  <div class="flex flex-col">
    <div class="rounded-lg overflow-hidden bg-gray-100" :class="stripeError ? 'bg-red-50 border border-red-500' : 'bg-gray-100'">
      <!-- Card Number -->
      <div class="flex items-center gap-x-3 px-4 py-3">
        <div ref="cardNumberEl" class="flex-1 h-5" />
      </div>

      <div class="border-t" :class="stripeError ? 'border-red-500' : 'border-gray-300'" />

      <!-- Expiry + CVC -->
      <div class="flex">
        <div class="flex-1 px-4 py-3">
          <div ref="cardExpiryEl" class="h-5" />
        </div>

        <div class="border-l" :class="stripeError ? 'border-red-500' : 'border-gray-300'" />

        <div class="flex-1 flex items-center gap-x-3 px-4 py-3">
          <div ref="cardCvcEl" class="flex-1 h-5" />
        </div>
      </div>
    </div>

    <p v-if="stripeError" class="text-xs text-red-500">{{ stripeError }}</p>
  </div>
</template>
